import { render } from "./policypublicity.vue?vue&type=template&id=1d62ea2c&scoped=true"
import script from "./policypublicity.vue?vue&type=script&lang=js"
export * from "./policypublicity.vue?vue&type=script&lang=js"

import "./policypublicity.vue?vue&type=style&index=0&id=1d62ea2c&scoped=true&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d62ea2c"]])

export default __exports__